'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _textArea = require('./styled/text-area');

var _textArea2 = _interopRequireDefault(_textArea);

var _validationIcon = require('./styled/validation-icon');

var _validationIcon2 = _interopRequireDefault(_validationIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TextArea, _Component);

  function TextArea() {
    (0, _classCallCheck3.default)(this, TextArea);
    return (0, _possibleConstructorReturn3.default)(this, (TextArea.__proto__ || (0, _getPrototypeOf2.default)(TextArea)).apply(this, arguments));
  }

  (0, _createClass3.default)(TextArea, [{
    key: 'getLabelPosition',
    value: function getLabelPosition() {
      return this.props.webformElement.getLabelDisplay();
    }
  }, {
    key: 'render',
    value: function render() {
      var attrs = {
        'aria-invalid': this.props.webformElement.isValid() ? null : true,
        'aria-required': this.props.field['#required'] ? true : null
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_textArea2.default, (0, _extends3.default)({
          labelDisplay: this.getLabelPosition(),
          success: this.props.webformElement.isValid(),
          onBlur: this.props.onBlur,
          onChange: this.props.onChange,
          value: this.props.value,
          name: this.props.field['#webform_key'],
          id: this.props.field['#webform_key'],
          disabled: !this.props.state.enabled,
          required: !this.props.state.required
        }, attrs)),
        _react2.default.createElement(_validationIcon2.default, { success: this.props.webformElement.isSuccess(), className: 'hrw-validation-icon' })
      );
    }
  }]);
  return TextArea;
}(_react.Component), _class.propTypes = {
  field: _propTypes2.default.shape({
    '#webform_key': _propTypes2.default.string.isRequired,
    '#required': _propTypes2.default.bool
  }).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
  webformElement: _propTypes2.default.instanceOf(_WebformElement2.default).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  state: _propTypes2.default.shape({
    required: _propTypes2.default.bool.isRequired,
    enabled: _propTypes2.default.bool.isRequired
  }).isRequired
}, _class.defaultProps = {
  value: null
}, _temp);
exports.default = TextArea;